import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NotificationItem } from '../../client/notificationsClient';
import { useNotifications } from '../../hooks/useNotifications';
import { outreachThreadPath, rfqPath, wizardStepPath } from '../../utils/wizardRoutes';
import NotificationBell from './NotificationBell';

/**
 * Where a notification leads: a supplier reply to its outreach thread, a
 * research result to the RFQ's discovery step, anything else to the RFQ's
 * current step.
 */
export const notificationPath = (n: NotificationItem): string => {
  // Research types first: they always lead to /rfqs/<id>/discovery, whatever else they carry.
  if (n.type === 'RESEARCH_READY' || n.type === 'RESEARCH_PROBLEM') {
    return wizardStepPath(n.rfqId, { step: 3, subStep: 3 });
  }
  if (n.threadId) return outreachThreadPath(n.rfqId, n.threadId);
  return rfqPath(n.rfqId);
};

/** The bell wired to the inbox and the router — the shell top bar and the wizard header both mount it. */
export const ConnectedNotificationBell: React.FC<{ onDark?: boolean }> = ({ onDark = false }) => {
  const navigate = useNavigate();
  const notifications = useNotifications();
  return (
    <NotificationBell
      onDark={onDark}
      unreadCount={notifications.unreadCount}
      items={notifications.items}
      onOpen={notifications.refetch}
      onSelect={(n) => {
        notifications.markRead(n.id);
        navigate(notificationPath(n));
      }}
      onMarkAllRead={notifications.markAllRead}
    />
  );
};

export default ConnectedNotificationBell;
